import { exchangeAgentGuidanceIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const deleteExchangeAgentGuidance = {
  name: "deleteExchangeAgentGuidance" as const,
  input: z.object({ id: exchangeAgentGuidanceIdFormat.schema }),
  output: z.object({}),
};
